// ReportInfocell Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CellContainer from '../../../../components/ListCell/CellContainer.jsx'

class ReportInfoCell extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string,
      contact: PropTypes.string,
      status: PropTypes.string,
      info: PropTypes.string,
      onView: PropTypes.func,
      width: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      title: '',
      contact: '',
      status: '',
      info: '',
      onView: null,
      width: ''
    }
  }

  render () {
    const { width } = this.props
    return (
      <CellContainer
        width={width}
        className='report-infocell list-cell'
        onClick={this._onClick.bind(this)}
      >
        {this._renderItems()}
      </CellContainer>
    )
  }

  /* Even handlers */
  _onClick () {
    if (this.props.onView) {
      this.props.onView()
    }
  }

  /* Private Function */
  _renderItems () {
    const title = this.props.title
    const status = this.props.status
    const info = this.props.info
    const contact = this.props.contact
    const statusCls = `status status-${this.props.status}`

    return (
      <div className='listrowcell infocell'>
        <div className='info'>
          <h4 className='title'>{title}</h4>
          <div className='cont'>
            {status && (
              <>
                <span className={statusCls}>{status}</span>
                <span className='spliter'>|</span>
              </>
            )}
            <span>{contact}</span>
            {info && (
              <>
                <span className='spliter'>|</span>
                <span>{info}</span>
              </>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default ReportInfoCell
